import http from "../01_axios"
import {
  apiRegisterOrganization,
  apiGetListPackage,
  apiGetAccount,
  apiUploadFile,
  apiRegisterIndividual,
  apiSendContact,
  apiGetMemberDetail,
  apiGetMembershipRegisterForm,
} from "./urls"

const getMembershipRegisterForm = body =>
  http.post(apiGetMembershipRegisterForm, body)

const getListPackage = body => http.post(apiGetListPackage, body)
const getAccount = body => http.post(apiGetAccount, body)
const uploadFile = body => http.post(apiUploadFile, body)
const RegisterOrganization = body => http.post(apiRegisterOrganization, body)
const RegisterIndividual = body => http.post(apiRegisterIndividual, body)
const SendContact = body => http.post(apiSendContact, body)
const getMemberDetail = params => http.get(apiGetMemberDetail, { params })

const GuestService = {
  RegisterOrganization,
  RegisterIndividual,
  getListPackage,
  getAccount,
  uploadFile,
  SendContact,
  getMemberDetail,
  getMembershipRegisterForm,
}

export default GuestService
